export default {"src":"/org/_next/static/media/check.bed74826.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};